import React from "react";
import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {CyClass} from "../../../../../../../common/cy-classes";
import {USResponsibleGamingBox} from "../boxes/us.responsible-gaming.box";

export const USResponsibleGamingComponent = observer(
    class USResponsibleGamingComponent extends OrbitComponent {
        private _onClickHandler = async () => {
            this.services.analytics.sendOrbitUserFlowEvent("Navigation","Header", 'Icon_nj_resp_game_icon');
            await this.services.linksNavigation.openResponsibleGaming();
        }
        render() {
            return (
                <USResponsibleGamingBox className={CyClass('cy-responsible-gaming-button')}
                                              onClick={this._onClickHandler}/>
            );
        }
    }
);